const EducationExperiences = [
  {
    time: "2015 - 2017",
    title: "MS in Computer Science",
    organization: "National Taiwan University",
    organizationLink: "https://www.ntu.edu.tw",
    contents: [
      {
        name: "Y.Chang",
        else: ` and J. Wu, "Multi-user Searchable
                      Encryption Scheme with Constant-Size Keys," in 2017 IEEE
                      7th International Symposium on Cloud and Service Computing
                      (SC2), Kanazawa, Japan, 2017 pp. 98-103. doi:
                      10.1109/SC2.2017.22`,
        link: "https://www.computer.org/csdl/proceedings-article/sc2/2017/5862a098/12OmNrJiCZ4",
        doi: "doi: 10.1109/SC2.2017.22",
      },
    ],
    interns: [
      {
        time: "07.2016 - 09.2016",
        title: "Software Developer Summer Intern",
        organization: "Industrial Technology Research Institute",
        organizationLink: "https://www.itri.org.tw",
        contents: [
          `• Used Java and Android to build a product implementing
                      the concept of smart home, helping users play music, get a
                      weather report, send a message, etc.`,
        ],
      },
    ],
    skills: ["Java", "Android"],
  },
  {
    time: "2011 - 2015",
    title: "BS in Computer Science",
    organization: "National Central University",
    organizationLink: "https://www.ncu.edu.tw/",
    interns: [
      {
        time: "07.2013 - 06.2014",
        title: "Software Developer Intern",
        organization: "Landseed Hospital",
        organizationLink: "https://www.landseedhospital.com.tw",
        contents: [
          `• Used Java and Android to develop a rehabilitation app
                      for patients to do some daily exercises by following the
                      instructions suggested by our doctors.`,
          `• Used JavaScript, HTML, CSS, PHP, and MySQL to build a
                      system for our doctors to handle patients' data.`,
        ],
      },
    ],
    skills: ["JavaScript", "HTML5", "CSS3", "PHP", "MySQL", "Java", "Android"],
  },
];

export default EducationExperiences;
